import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import useForm from 'react-hook-form';
import Loader from '../common/loader';
import api from '../../config/axios';
import { date } from '../../utils/date';
import { useStateValue } from '../../store';

function Clients(props) {
    const { handleSubmit, register } = useForm();
    const [{ auth }] = useStateValue();
    const [loaded, setLoaded] = useState(false);
    const [clients, setClients] = useState([]);
    const [pagination, setPagination] = useState({ page: 1 });
    const [filter, setFilter] = useState(true);
    const [showMoreFilters, setShowMoreFilters] = useState(false);

    const franchiseId = auth.user.franchiseId || null;
    const baseUrlClients = franchiseId ? `/client/franchise?franchiseId=${franchiseId}&` : '/client?';

    useEffect(() => {
        fetchClients(pagination.page);
    }, []);

    const fetchClients = async (page) => {
        const { data } = await api.get(`${baseUrlClients}page=${page}`);
        const clients = parseClients(data.data.rows);

        const dataPagination = {
            ...data.meta.pagination,
            total: data.data.count,
        };
        setClients(clients);
        setPagination(dataPagination);
        setLoaded(true);
    };

    const handleFilter = (data) => {
        const params = [];
        if (data.name) params.push(`name=${encodeURIComponent(data.name)}`);
        if (data.phone) params.push(`phone=${encodeURIComponent(data.phone)}`);
        if (data.street) params.push(`street=${encodeURIComponent(data.street)}`);

        filterClients(params.join('&'));
    };

    const filterClients = async (queryString = '') => {
        const { data } = await api.get(`${baseUrlClients}page=1&${queryString}`);
        const clients = parseClients(data.data.rows);

        const dataPagination = {
            ...data.meta.pagination,
            total: data.data.count,
        };
        setClients(clients);
        setPagination(dataPagination);
        setLoaded(true);
    };

    const parseClients = (array) => {
        return array.map((item) => ({
            id: item.id,
            name: item.name,
            email: item.email,
            phone_number: item.phone_number,
            createdByUserId: item.createdByUserId,
            createdAt: item.createdAt,
        }));
    };

    const handlePage = (page) => {
        fetchClients(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const totalPages = () => Math.ceil(pagination.total / pagination.length);

    if (!loaded)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );
    return (
        <Fragment>
            {/* <!-- Container-fluid starts--> */}
            <div className="container-fluid rents-wrapper pt-2">
                <div className="row">
                    <div className="col-sm-12">
                        <div
                            className={`card ${!filter ? 'filter-hidden' : ''}`}
                            style={{ marginBottom: 10 }}
                        >
                            <form type="submit" onSubmit={handleSubmit(handleFilter)}>
                                <div className="card-body">
                                    <div className="input-group mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nombre del cliente..."
                                            name="name"
                                            ref={register({
                                                required: false,
                                            })}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() =>
                                                    setShowMoreFilters(!showMoreFilters)
                                                }
                                                aria-label="Buscar por teléfono o dirección"
                                            >
                                                <i
                                                    className={`fa ${
                                                        showMoreFilters
                                                            ? 'fa-chevron-up'
                                                            : 'fa-chevron-down'
                                                    }`}
                                                >
                                                    {' '}
                                                </i>
                                            </button>
                                        </div>
                                    </div>
                                    {showMoreFilters && (
                                        <Fragment>
                                            <div className="form-group">
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    placeholder="Teléfono (ej: 0414...)"
                                                    name="phone"
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Dirección (calle, edificio, sector...)"
                                                    name="street"
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                />
                                            </div>
                                        </Fragment>
                                    )}
                                    <button
                                        className="btn btn-primary btn-block mb-3"
                                        type="submit"
                                    >
                                        <i className="fa fa-search"></i> Buscar
                                    </button>
                                    <div className="d-flex justify-content-between">
                                        <Link
                                            className="btn btn-secondary"
                                            to={`${process.env.PUBLIC_URL}/notificacion`}
                                        >
                                            <i className="fa fa-bell"></i>
                                        </Link>
                                        <Link
                                            className="btn btn-success"
                                            to={`${process.env.PUBLIC_URL}/nuevo-cliente`}
                                        >
                                            Nuevo cliente
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                {clients.length === 0 ? (
                                    <p className="text-center text-muted mb-0">
                                        No se encontraron clientes
                                    </p>
                                ) : (
                                    <div className="list-group">
                                        {clients.map((client) => (
                                            <div
                                                key={client.id}
                                                className="list-group-item list-group-item-action flex-column align-items-start"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                    props.history.push(
                                                        `/clientes/${client.id}`,
                                                    )
                                                }
                                            >
                                                <div className="d-flex w-100 justify-content-between align-items-center">
                                                    <strong>{client.name}</strong>
                                                    <span className="badge badge-primary">
                                                        #{client.id}
                                                    </span>
                                                </div>
                                                <div
                                                    className="text-muted"
                                                    style={{
                                                        fontSize: '0.85rem',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                    }}
                                                >
                                                    {client.email}
                                                </div>
                                                <div
                                                    className="d-flex w-100 justify-content-between align-items-center"
                                                    style={{ fontSize: '0.9rem' }}
                                                >
                                                    <span>+{client.phone_number}</span>
                                                    {client.createdAt && (
                                                        <span className="text-muted">
                                                            {date(client.createdAt)}
                                                        </span>
                                                    )}
                                                </div>
                                                {client.createdByUserId && (
                                                    <span
                                                        className="text-muted"
                                                        style={{ fontSize: '0.8rem' }}
                                                    >
                                                        Creado por usuario #
                                                        {client.createdByUserId}
                                                    </span>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="d-flex flex-column align-items-center mt-3">
                                    <div className="d-flex mb-2">
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            style={{ marginRight: 8 }}
                                            disabled={pagination.page <= 1}
                                            onClick={() => handlePage(pagination.page - 1)}
                                        >
                                            ← Anterior
                                        </button>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            disabled={pagination.page >= totalPages()}
                                            onClick={() => handlePage(pagination.page + 1)}
                                        >
                                            Siguiente →
                                        </button>
                                    </div>
                                    <span
                                        className="text-muted"
                                        style={{ fontSize: '0.85rem' }}
                                    >
                                        {pagination.total} clientes · Página{' '}
                                        {pagination.page} de {totalPages()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Container-fluid Ends--> */}
        </Fragment>
    );
}

export default Clients;
